export default "__VITE_ASSET__BVUOqtTa__"